export default "__VITE_ASSET__DUK2lxu___"